"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
var NS3466310101622778499 = require("./abfv3-digest_generated");
/**
 * @constructor
 */
var Ayvri;
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var TrackFrame3_0 = /** @class */ (function () {
            function TrackFrame3_0() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {TrackFrame3_0}
             */
            TrackFrame3_0.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {TrackFrame3_0=} obj
             * @returns {TrackFrame3_0}
             */
            TrackFrame3_0.getRootAsTrackFrame3_0 = function (bb, obj) {
                return (obj || new TrackFrame3_0).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.latitude = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.latitudeLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackFrame3_0.prototype.latitudeArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.longitude = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.longitudeLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackFrame3_0.prototype.longitudeArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.height = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.heightLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackFrame3_0.prototype.heightArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.time = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.timeLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackFrame3_0.prototype.timeArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.terrain = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.terrainLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackFrame3_0.prototype.terrainArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.originalHeight = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 14);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.originalHeightLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 14);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackFrame3_0.prototype.originalHeightArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 14);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.depth = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.depthLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint8Array}
             */
            TrackFrame3_0.prototype.depthArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.speed = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 18);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.speedLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 18);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackFrame3_0.prototype.speedArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 18);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.distance = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 20);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.distanceLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 20);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackFrame3_0.prototype.distanceArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 20);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.heartrate = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 22);
                return offset ? this.bb.readUint16(this.bb.__vector(this.bb_pos + offset) + index * 2) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.heartrateLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 22);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint16Array}
             */
            TrackFrame3_0.prototype.heartrateArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 22);
                return offset ? new Uint16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.cadence = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 24);
                return offset ? this.bb.readUint16(this.bb.__vector(this.bb_pos + offset) + index * 2) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.cadenceLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 24);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint16Array}
             */
            TrackFrame3_0.prototype.cadenceArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 24);
                return offset ? new Uint16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_0.prototype.temperature = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 26);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_0.prototype.temperatureLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 26);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackFrame3_0.prototype.temperatureArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 26);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            TrackFrame3_0.startTrackFrame3_0 = function (builder) {
                builder.startObject(12);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} latitudeOffset
             */
            TrackFrame3_0.addLatitude = function (builder, latitudeOffset) {
                builder.addFieldOffset(0, latitudeOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createLatitudeVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startLatitudeVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} longitudeOffset
             */
            TrackFrame3_0.addLongitude = function (builder, longitudeOffset) {
                builder.addFieldOffset(1, longitudeOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createLongitudeVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startLongitudeVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} heightOffset
             */
            TrackFrame3_0.addHeight = function (builder, heightOffset) {
                builder.addFieldOffset(2, heightOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createHeightVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startHeightVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} timeOffset
             */
            TrackFrame3_0.addTime = function (builder, timeOffset) {
                builder.addFieldOffset(3, timeOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createTimeVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startTimeVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} terrainOffset
             */
            TrackFrame3_0.addTerrain = function (builder, terrainOffset) {
                builder.addFieldOffset(4, terrainOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createTerrainVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startTerrainVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} originalHeightOffset
             */
            TrackFrame3_0.addOriginalHeight = function (builder, originalHeightOffset) {
                builder.addFieldOffset(5, originalHeightOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createOriginalHeightVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startOriginalHeightVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} depthOffset
             */
            TrackFrame3_0.addDepth = function (builder, depthOffset) {
                builder.addFieldOffset(6, depthOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createDepthVector = function (builder, data) {
                builder.startVector(1, data.length, 1);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt8(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startDepthVector = function (builder, numElems) {
                builder.startVector(1, numElems, 1);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} speedOffset
             */
            TrackFrame3_0.addSpeed = function (builder, speedOffset) {
                builder.addFieldOffset(7, speedOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createSpeedVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startSpeedVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} distanceOffset
             */
            TrackFrame3_0.addDistance = function (builder, distanceOffset) {
                builder.addFieldOffset(8, distanceOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createDistanceVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startDistanceVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} heartrateOffset
             */
            TrackFrame3_0.addHeartrate = function (builder, heartrateOffset) {
                builder.addFieldOffset(9, heartrateOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createHeartrateVector = function (builder, data) {
                builder.startVector(2, data.length, 2);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt16(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startHeartrateVector = function (builder, numElems) {
                builder.startVector(2, numElems, 2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} cadenceOffset
             */
            TrackFrame3_0.addCadence = function (builder, cadenceOffset) {
                builder.addFieldOffset(10, cadenceOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createCadenceVector = function (builder, data) {
                builder.startVector(2, data.length, 2);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt16(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startCadenceVector = function (builder, numElems) {
                builder.startVector(2, numElems, 2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} temperatureOffset
             */
            TrackFrame3_0.addTemperature = function (builder, temperatureOffset) {
                builder.addFieldOffset(11, temperatureOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.createTemperatureVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_0.startTemperatureVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_0.endTrackFrame3_0 = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            return TrackFrame3_0;
        }());
        ABF.TrackFrame3_0 = TrackFrame3_0;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
/**
 * @constructor
 */
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var TrackFrameChannelShort = /** @class */ (function () {
            function TrackFrameChannelShort() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {TrackFrameChannelShort}
             */
            TrackFrameChannelShort.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {TrackFrameChannelShort=} obj
             * @returns {TrackFrameChannelShort}
             */
            TrackFrameChannelShort.getRootAsTrackFrameChannelShort = function (bb, obj) {
                return (obj || new TrackFrameChannelShort).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrameChannelShort.prototype.initial = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrameChannelShort.prototype.dmin = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrameChannelShort.prototype.dmax = function () {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrameChannelShort.prototype.deltas = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.readInt16(this.bb.__vector(this.bb_pos + offset) + index * 2) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrameChannelShort.prototype.deltasLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Int16Array}
             */
            TrackFrameChannelShort.prototype.deltasArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? new Int16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            TrackFrameChannelShort.startTrackFrameChannelShort = function (builder) {
                builder.startObject(4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} initial
             */
            TrackFrameChannelShort.addInitial = function (builder, initial) {
                builder.addFieldFloat64(0, initial, 0.0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} dmin
             */
            TrackFrameChannelShort.addDmin = function (builder, dmin) {
                builder.addFieldFloat64(1, dmin, 0.0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} dmax
             */
            TrackFrameChannelShort.addDmax = function (builder, dmax) {
                builder.addFieldFloat64(2, dmax, 0.0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} deltasOffset
             */
            TrackFrameChannelShort.addDeltas = function (builder, deltasOffset) {
                builder.addFieldOffset(3, deltasOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrameChannelShort.createDeltasVector = function (builder, data) {
                builder.startVector(2, data.length, 2);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt16(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrameChannelShort.startDeltasVector = function (builder, numElems) {
                builder.startVector(2, numElems, 2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            TrackFrameChannelShort.endTrackFrameChannelShort = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            return TrackFrameChannelShort;
        }());
        ABF.TrackFrameChannelShort = TrackFrameChannelShort;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
/**
 * @constructor
 */
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var TrackFrameMonotonicDeltaChannel = /** @class */ (function () {
            function TrackFrameMonotonicDeltaChannel() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {TrackFrameMonotonicDeltaChannel}
             */
            TrackFrameMonotonicDeltaChannel.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {TrackFrameMonotonicDeltaChannel=} obj
             * @returns {TrackFrameMonotonicDeltaChannel}
             */
            TrackFrameMonotonicDeltaChannel.getRootAsTrackFrameMonotonicDeltaChannel = function (bb, obj) {
                return (obj || new TrackFrameMonotonicDeltaChannel).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrameMonotonicDeltaChannel.prototype.initial = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrameMonotonicDeltaChannel.prototype.scale = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrameMonotonicDeltaChannel.prototype.deltas = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? this.bb.readUint16(this.bb.__vector(this.bb_pos + offset) + index * 2) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrameMonotonicDeltaChannel.prototype.deltasLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint16Array}
             */
            TrackFrameMonotonicDeltaChannel.prototype.deltasArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? new Uint16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            TrackFrameMonotonicDeltaChannel.startTrackFrameMonotonicDeltaChannel = function (builder) {
                builder.startObject(3);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} initial
             */
            TrackFrameMonotonicDeltaChannel.addInitial = function (builder, initial) {
                builder.addFieldFloat64(0, initial, 0.0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} scale
             */
            TrackFrameMonotonicDeltaChannel.addScale = function (builder, scale) {
                builder.addFieldFloat64(1, scale, 0.0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} deltasOffset
             */
            TrackFrameMonotonicDeltaChannel.addDeltas = function (builder, deltasOffset) {
                builder.addFieldOffset(2, deltasOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrameMonotonicDeltaChannel.createDeltasVector = function (builder, data) {
                builder.startVector(2, data.length, 2);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt16(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrameMonotonicDeltaChannel.startDeltasVector = function (builder, numElems) {
                builder.startVector(2, numElems, 2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            TrackFrameMonotonicDeltaChannel.endTrackFrameMonotonicDeltaChannel = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            return TrackFrameMonotonicDeltaChannel;
        }());
        ABF.TrackFrameMonotonicDeltaChannel = TrackFrameMonotonicDeltaChannel;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
/**
 * @constructor
 */
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var TrackFrameLongMonotonicDeltaChannel = /** @class */ (function () {
            function TrackFrameLongMonotonicDeltaChannel() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {TrackFrameLongMonotonicDeltaChannel}
             */
            TrackFrameLongMonotonicDeltaChannel.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {TrackFrameLongMonotonicDeltaChannel=} obj
             * @returns {TrackFrameLongMonotonicDeltaChannel}
             */
            TrackFrameLongMonotonicDeltaChannel.getRootAsTrackFrameLongMonotonicDeltaChannel = function (bb, obj) {
                return (obj || new TrackFrameLongMonotonicDeltaChannel).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrameLongMonotonicDeltaChannel.prototype.initial = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrameLongMonotonicDeltaChannel.prototype.deltas = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrameLongMonotonicDeltaChannel.prototype.deltasLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint32Array}
             */
            TrackFrameLongMonotonicDeltaChannel.prototype.deltasArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            TrackFrameLongMonotonicDeltaChannel.startTrackFrameLongMonotonicDeltaChannel = function (builder) {
                builder.startObject(2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} initial
             */
            TrackFrameLongMonotonicDeltaChannel.addInitial = function (builder, initial) {
                builder.addFieldFloat64(0, initial, 0.0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} deltasOffset
             */
            TrackFrameLongMonotonicDeltaChannel.addDeltas = function (builder, deltasOffset) {
                builder.addFieldOffset(1, deltasOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrameLongMonotonicDeltaChannel.createDeltasVector = function (builder, data) {
                builder.startVector(4, data.length, 4);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt32(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrameLongMonotonicDeltaChannel.startDeltasVector = function (builder, numElems) {
                builder.startVector(4, numElems, 4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            TrackFrameLongMonotonicDeltaChannel.endTrackFrameLongMonotonicDeltaChannel = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            return TrackFrameLongMonotonicDeltaChannel;
        }());
        ABF.TrackFrameLongMonotonicDeltaChannel = TrackFrameLongMonotonicDeltaChannel;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
/**
 * @constructor
 */
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var SparseTextChannel = /** @class */ (function () {
            function SparseTextChannel() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {SparseTextChannel}
             */
            SparseTextChannel.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {SparseTextChannel=} obj
             * @returns {SparseTextChannel}
             */
            SparseTextChannel.getRootAsSparseTextChannel = function (bb, obj) {
                return (obj || new SparseTextChannel).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            SparseTextChannel.prototype.indexes = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            SparseTextChannel.prototype.indexesLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint32Array}
             */
            SparseTextChannel.prototype.indexesArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            SparseTextChannel.prototype.values = function (index, optionalEncoding) {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.__string(this.bb.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
            };
            ;
            /**
             * @returns {number}
             */
            SparseTextChannel.prototype.valuesLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            SparseTextChannel.startSparseTextChannel = function (builder) {
                builder.startObject(2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} indexesOffset
             */
            SparseTextChannel.addIndexes = function (builder, indexesOffset) {
                builder.addFieldOffset(0, indexesOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            SparseTextChannel.createIndexesVector = function (builder, data) {
                builder.startVector(4, data.length, 4);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt32(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            SparseTextChannel.startIndexesVector = function (builder, numElems) {
                builder.startVector(4, numElems, 4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} valuesOffset
             */
            SparseTextChannel.addValues = function (builder, valuesOffset) {
                builder.addFieldOffset(1, valuesOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<flatbuffers.Offset>} data
             * @returns {flatbuffers.Offset}
             */
            SparseTextChannel.createValuesVector = function (builder, data) {
                builder.startVector(4, data.length, 4);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addOffset(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            SparseTextChannel.startValuesVector = function (builder, numElems) {
                builder.startVector(4, numElems, 4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            SparseTextChannel.endSparseTextChannel = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            return SparseTextChannel;
        }());
        ABF.SparseTextChannel = SparseTextChannel;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
/**
 * @constructor
 */
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var SparseNumericChannel = /** @class */ (function () {
            function SparseNumericChannel() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {SparseNumericChannel}
             */
            SparseNumericChannel.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {SparseNumericChannel=} obj
             * @returns {SparseNumericChannel}
             */
            SparseNumericChannel.getRootAsSparseNumericChannel = function (bb, obj) {
                return (obj || new SparseNumericChannel).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            SparseNumericChannel.prototype.indexes = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            SparseNumericChannel.prototype.indexesLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint32Array}
             */
            SparseNumericChannel.prototype.indexesArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            SparseNumericChannel.prototype.values = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            SparseNumericChannel.prototype.valuesLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            SparseNumericChannel.prototype.valuesArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            SparseNumericChannel.startSparseNumericChannel = function (builder) {
                builder.startObject(2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} indexesOffset
             */
            SparseNumericChannel.addIndexes = function (builder, indexesOffset) {
                builder.addFieldOffset(0, indexesOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            SparseNumericChannel.createIndexesVector = function (builder, data) {
                builder.startVector(4, data.length, 4);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt32(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            SparseNumericChannel.startIndexesVector = function (builder, numElems) {
                builder.startVector(4, numElems, 4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} valuesOffset
             */
            SparseNumericChannel.addValues = function (builder, valuesOffset) {
                builder.addFieldOffset(1, valuesOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            SparseNumericChannel.createValuesVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            SparseNumericChannel.startValuesVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            SparseNumericChannel.endSparseNumericChannel = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            return SparseNumericChannel;
        }());
        ABF.SparseNumericChannel = SparseNumericChannel;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
/**
 * @constructor
 */
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var ExtensionChannel = /** @class */ (function () {
            function ExtensionChannel() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {ExtensionChannel}
             */
            ExtensionChannel.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {ExtensionChannel=} obj
             * @returns {ExtensionChannel}
             */
            ExtensionChannel.getRootAsExtensionChannel = function (bb, obj) {
                return (obj || new ExtensionChannel).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            ExtensionChannel.prototype.name = function (optionalEncoding) {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.SparseTextChannel=} obj
             * @returns {Ayvri.ABF.SparseTextChannel|null}
             */
            ExtensionChannel.prototype.sparseText = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? (obj || new Ayvri.ABF.SparseTextChannel).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.SparseNumericChannel=} obj
             * @returns {Ayvri.ABF.SparseNumericChannel|null}
             */
            ExtensionChannel.prototype.sparseNumeric = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? (obj || new Ayvri.ABF.SparseNumericChannel).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            ExtensionChannel.prototype.denseText = function (index, optionalEncoding) {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.__string(this.bb.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
            };
            ;
            /**
             * @returns {number}
             */
            ExtensionChannel.prototype.denseTextLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            ExtensionChannel.prototype.denseNumeric = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            ExtensionChannel.prototype.denseNumericLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            ExtensionChannel.prototype.denseNumericArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            ExtensionChannel.startExtensionChannel = function (builder) {
                builder.startObject(5);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} nameOffset
             */
            ExtensionChannel.addName = function (builder, nameOffset) {
                builder.addFieldOffset(0, nameOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} sparseTextOffset
             */
            ExtensionChannel.addSparseText = function (builder, sparseTextOffset) {
                builder.addFieldOffset(1, sparseTextOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} sparseNumericOffset
             */
            ExtensionChannel.addSparseNumeric = function (builder, sparseNumericOffset) {
                builder.addFieldOffset(2, sparseNumericOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} denseTextOffset
             */
            ExtensionChannel.addDenseText = function (builder, denseTextOffset) {
                builder.addFieldOffset(3, denseTextOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<flatbuffers.Offset>} data
             * @returns {flatbuffers.Offset}
             */
            ExtensionChannel.createDenseTextVector = function (builder, data) {
                builder.startVector(4, data.length, 4);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addOffset(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            ExtensionChannel.startDenseTextVector = function (builder, numElems) {
                builder.startVector(4, numElems, 4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} denseNumericOffset
             */
            ExtensionChannel.addDenseNumeric = function (builder, denseNumericOffset) {
                builder.addFieldOffset(4, denseNumericOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            ExtensionChannel.createDenseNumericVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            ExtensionChannel.startDenseNumericVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            ExtensionChannel.endExtensionChannel = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            return ExtensionChannel;
        }());
        ABF.ExtensionChannel = ExtensionChannel;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
/**
 * @constructor
 */
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var TrackFrame3_1 = /** @class */ (function () {
            function TrackFrame3_1() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {TrackFrame3_1}
             */
            TrackFrame3_1.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {TrackFrame3_1=} obj
             * @returns {TrackFrame3_1}
             */
            TrackFrame3_1.getRootAsTrackFrame3_1 = function (bb, obj) {
                return (obj || new TrackFrame3_1).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrameChannelShort=} obj
             * @returns {Ayvri.ABF.TrackFrameChannelShort|null}
             */
            TrackFrame3_1.prototype.latitude = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? (obj || new Ayvri.ABF.TrackFrameChannelShort).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrameChannelShort=} obj
             * @returns {Ayvri.ABF.TrackFrameChannelShort|null}
             */
            TrackFrame3_1.prototype.longitude = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? (obj || new Ayvri.ABF.TrackFrameChannelShort).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrameChannelShort=} obj
             * @returns {Ayvri.ABF.TrackFrameChannelShort|null}
             */
            TrackFrame3_1.prototype.height = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? (obj || new Ayvri.ABF.TrackFrameChannelShort).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel=} obj
             * @returns {Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel|null}
             */
            TrackFrame3_1.prototype.time = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? (obj || new Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrameChannelShort=} obj
             * @returns {Ayvri.ABF.TrackFrameChannelShort|null}
             */
            TrackFrame3_1.prototype.terrain = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? (obj || new Ayvri.ABF.TrackFrameChannelShort).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrameChannelShort=} obj
             * @returns {Ayvri.ABF.TrackFrameChannelShort|null}
             */
            TrackFrame3_1.prototype.originalHeight = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 14);
                return offset ? (obj || new Ayvri.ABF.TrackFrameChannelShort).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_1.prototype.depth = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_1.prototype.depthLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint8Array}
             */
            TrackFrame3_1.prototype.depthArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrameChannelShort=} obj
             * @returns {Ayvri.ABF.TrackFrameChannelShort|null}
             */
            TrackFrame3_1.prototype.speed = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 18);
                return offset ? (obj || new Ayvri.ABF.TrackFrameChannelShort).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrameChannelShort=} obj
             * @returns {Ayvri.ABF.TrackFrameChannelShort|null}
             */
            TrackFrame3_1.prototype.distance = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 20);
                return offset ? (obj || new Ayvri.ABF.TrackFrameChannelShort).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_1.prototype.heartrate = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 22);
                return offset ? this.bb.readUint16(this.bb.__vector(this.bb_pos + offset) + index * 2) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_1.prototype.heartrateLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 22);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint16Array}
             */
            TrackFrame3_1.prototype.heartrateArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 22);
                return offset ? new Uint16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackFrame3_1.prototype.cadence = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 24);
                return offset ? this.bb.readUint16(this.bb.__vector(this.bb_pos + offset) + index * 2) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame3_1.prototype.cadenceLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 24);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint16Array}
             */
            TrackFrame3_1.prototype.cadenceArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 24);
                return offset ? new Uint16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrameChannelShort=} obj
             * @returns {Ayvri.ABF.TrackFrameChannelShort|null}
             */
            TrackFrame3_1.prototype.temperature = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 26);
                return offset ? (obj || new Ayvri.ABF.TrackFrameChannelShort).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            TrackFrame3_1.startTrackFrame3_1 = function (builder) {
                builder.startObject(12);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} latitudeOffset
             */
            TrackFrame3_1.addLatitude = function (builder, latitudeOffset) {
                builder.addFieldOffset(0, latitudeOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} longitudeOffset
             */
            TrackFrame3_1.addLongitude = function (builder, longitudeOffset) {
                builder.addFieldOffset(1, longitudeOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} heightOffset
             */
            TrackFrame3_1.addHeight = function (builder, heightOffset) {
                builder.addFieldOffset(2, heightOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} timeOffset
             */
            TrackFrame3_1.addTime = function (builder, timeOffset) {
                builder.addFieldOffset(3, timeOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} terrainOffset
             */
            TrackFrame3_1.addTerrain = function (builder, terrainOffset) {
                builder.addFieldOffset(4, terrainOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} originalHeightOffset
             */
            TrackFrame3_1.addOriginalHeight = function (builder, originalHeightOffset) {
                builder.addFieldOffset(5, originalHeightOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} depthOffset
             */
            TrackFrame3_1.addDepth = function (builder, depthOffset) {
                builder.addFieldOffset(6, depthOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_1.createDepthVector = function (builder, data) {
                builder.startVector(1, data.length, 1);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt8(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_1.startDepthVector = function (builder, numElems) {
                builder.startVector(1, numElems, 1);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} speedOffset
             */
            TrackFrame3_1.addSpeed = function (builder, speedOffset) {
                builder.addFieldOffset(7, speedOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} distanceOffset
             */
            TrackFrame3_1.addDistance = function (builder, distanceOffset) {
                builder.addFieldOffset(8, distanceOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} heartrateOffset
             */
            TrackFrame3_1.addHeartrate = function (builder, heartrateOffset) {
                builder.addFieldOffset(9, heartrateOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_1.createHeartrateVector = function (builder, data) {
                builder.startVector(2, data.length, 2);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt16(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_1.startHeartrateVector = function (builder, numElems) {
                builder.startVector(2, numElems, 2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} cadenceOffset
             */
            TrackFrame3_1.addCadence = function (builder, cadenceOffset) {
                builder.addFieldOffset(10, cadenceOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_1.createCadenceVector = function (builder, data) {
                builder.startVector(2, data.length, 2);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt16(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame3_1.startCadenceVector = function (builder, numElems) {
                builder.startVector(2, numElems, 2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} temperatureOffset
             */
            TrackFrame3_1.addTemperature = function (builder, temperatureOffset) {
                builder.addFieldOffset(11, temperatureOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            TrackFrame3_1.endTrackFrame3_1 = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            return TrackFrame3_1;
        }());
        ABF.TrackFrame3_1 = TrackFrame3_1;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
/**
 * @constructor
 */
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var TrackFrame = /** @class */ (function () {
            function TrackFrame() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {TrackFrame}
             */
            TrackFrame.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {TrackFrame=} obj
             * @returns {TrackFrame}
             */
            TrackFrame.getRootAsTrackFrame = function (bb, obj) {
                return (obj || new TrackFrame).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame.prototype.trackId = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame.prototype.frameStartIndex = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame.prototype.frameLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame.prototype.trackLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrame3_0=} obj
             * @returns {Ayvri.ABF.TrackFrame3_0|null}
             */
            TrackFrame.prototype.frame30 = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? (obj || new Ayvri.ABF.TrackFrame3_0).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {Ayvri.ABF.TrackFrame3_1=} obj
             * @returns {Ayvri.ABF.TrackFrame3_1|null}
             */
            TrackFrame.prototype.frame31 = function (obj) {
                var offset = this.bb.__offset(this.bb_pos, 14);
                return offset ? (obj || new Ayvri.ABF.TrackFrame3_1).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
            };
            ;
            /**
             * @param {number} index
             * @param {Ayvri.ABF.ExtensionChannel=} obj
             * @returns {Ayvri.ABF.ExtensionChannel}
             */
            TrackFrame.prototype.extensions = function (index, obj) {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? (obj || new Ayvri.ABF.ExtensionChannel).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
            };
            ;
            /**
             * @returns {number}
             */
            TrackFrame.prototype.extensionsLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            TrackFrame.startTrackFrame = function (builder) {
                builder.startObject(7);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} trackId
             */
            TrackFrame.addTrackId = function (builder, trackId) {
                builder.addFieldInt32(0, trackId, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} frameStartIndex
             */
            TrackFrame.addFrameStartIndex = function (builder, frameStartIndex) {
                builder.addFieldInt32(1, frameStartIndex, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} frameLength
             */
            TrackFrame.addFrameLength = function (builder, frameLength) {
                builder.addFieldInt32(2, frameLength, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} trackLength
             */
            TrackFrame.addTrackLength = function (builder, trackLength) {
                builder.addFieldInt32(3, trackLength, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} frame30Offset
             */
            TrackFrame.addFrame30 = function (builder, frame30Offset) {
                builder.addFieldOffset(4, frame30Offset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} frame31Offset
             */
            TrackFrame.addFrame31 = function (builder, frame31Offset) {
                builder.addFieldOffset(5, frame31Offset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} extensionsOffset
             */
            TrackFrame.addExtensions = function (builder, extensionsOffset) {
                builder.addFieldOffset(6, extensionsOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<flatbuffers.Offset>} data
             * @returns {flatbuffers.Offset}
             */
            TrackFrame.createExtensionsVector = function (builder, data) {
                builder.startVector(4, data.length, 4);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addOffset(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackFrame.startExtensionsVector = function (builder, numElems) {
                builder.startVector(4, numElems, 4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            TrackFrame.endTrackFrame = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            return TrackFrame;
        }());
        ABF.TrackFrame = TrackFrame;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
/**
 * @constructor
 */
(function (Ayvri) {
    var ABF;
    (function (ABF_1) {
        var ABF = /** @class */ (function () {
            function ABF() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {ABF}
             */
            ABF.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {ABF=} obj
             * @returns {ABF}
             */
            ABF.getRootAsABF = function (bb, obj) {
                return (obj || new ABF).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @param {number} index
             * @param {Ayvri.ABF.TrackFrame=} obj
             * @returns {Ayvri.ABF.TrackFrame}
             */
            ABF.prototype.tracks = function (index, obj) {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? (obj || new Ayvri.ABF.TrackFrame).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
            };
            ;
            /**
             * @returns {number}
             */
            ABF.prototype.tracksLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @param {number} index
             * @param {Ayvri.ABF.TrackDigest=} obj
             * @returns {Ayvri.ABF.TrackDigest}
             */
            ABF.prototype.digests = function (index, obj) {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? (obj || new NS3466310101622778499.Ayvri.ABF.TrackDigest).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
            };
            ;
            /**
             * @returns {number}
             */
            ABF.prototype.digestsLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            ABF.startABF = function (builder) {
                builder.startObject(2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} tracksOffset
             */
            ABF.addTracks = function (builder, tracksOffset) {
                builder.addFieldOffset(0, tracksOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<flatbuffers.Offset>} data
             * @returns {flatbuffers.Offset}
             */
            ABF.createTracksVector = function (builder, data) {
                builder.startVector(4, data.length, 4);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addOffset(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            ABF.startTracksVector = function (builder, numElems) {
                builder.startVector(4, numElems, 4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} digestsOffset
             */
            ABF.addDigests = function (builder, digestsOffset) {
                builder.addFieldOffset(1, digestsOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<flatbuffers.Offset>} data
             * @returns {flatbuffers.Offset}
             */
            ABF.createDigestsVector = function (builder, data) {
                builder.startVector(4, data.length, 4);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addOffset(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            ABF.startDigestsVector = function (builder, numElems) {
                builder.startVector(4, numElems, 4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            ABF.endABF = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} offset
             */
            ABF.finishABFBuffer = function (builder, offset) {
                builder.finish(offset);
            };
            ;
            return ABF;
        }());
        ABF_1.ABF = ABF;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
